import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import { notification, Table, Pagination, Input, Modal } from 'antd';

@inject('commonStore','centerInfoStore')
@observer
class CenterListModal extends Component {
  state = {
    ceNm: '',

    selectedRowKeys: [],
    selectedRows: []
  };

  UNSAFE_componentWillMount() {
    this.props.centerInfoStore.setCommonStoreInfo(this.props.commonStore);
    this.props.centerInfoStore.onClear();
  }
  
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.modalOpen !== this.props.modalOpen && nextProps.modalOpen === true) {
      this.props.centerInfoStore.onChangValue('ceNm', '');
      this.props.centerInfoStore.disCenterList(1, 5, 'Y');
      this.setState({
        ceNm: '',

        selectedRowKeys: [],
        selectedRows: []
      });
    }
  }

  onPageChange = (pageIdx) => {
    // console.log('page:', page);
    this.props.centerInfoStore.disCenterList(pageIdx);
  };

  onSearch = () => {
    this.props.centerInfoStore.onChangValue('ceNm', this.state.ceNm);
    this.props.centerInfoStore.disCenterList(1);
  };

  onPressEnter = (e) => {
    if (e.key === 'Enter') {
      this.onSearch();
    }
  };

  render() {
    const {
      centerList,
      pageInfo,
    } = this.props.centerInfoStore;
    const {
      ceNm,
      selectedRowKeys,
      selectedRows
    } = this.state;
    const columns = [
      { title: 'No', dataIndex: 'RNUM',  width: '10%', align: 'center' },
      { title: '센터코드', dataIndex: 'ceCd', width: '40%', align: 'center',
        render: (item, record) => { return(
          record.ceType === process.env.REACT_APP_TYPE_BRANCH ? <span style={{fontWeight: "bold"}}>{item}</span> : item
        )}
      },
      { title: '센터', dataIndex: 'ceNm', width: '48%', align: 'center',
        render: (item, record) => { return(
          record.ceType === process.env.REACT_APP_TYPE_BRANCH ? <span style={{fontWeight: "bold"}}>{item}</span> : item
        )}
      }
    ];

    const rowSelection = {
      columnWidth: '2%',
      selectedRowKeys,
      onChange: (selectedRowKeys, selectedRows) => {
        //console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        this.setState({selectedRowKeys, selectedRows});
      }
    };

    return (
      <Modal
        width={600}
        title="센터 검색"
        cancelText={"취소"}
        okText={"확인"}
        closable={false}
        visible={this.props.modalOpen}
        onCancel={this.props.modalClose}
        onOk={()=>{
          if (selectedRows.length > 0) {
            this.props.setCenterInfo(selectedRows[0]);
            this.props.modalClose();
          } else {
            notification.warning({placement: 'bottomLeft', message: `센터를 선택해주세요.`, duration: 2});
          }
        }}
      >
        센터 : 
        <Input.Search
          placeholder="센터명을 입력하세요"
          value={ceNm}
          onChange={(e)=>this.setState({ceNm: e.target.value})}
          onPressEnter={this.onPressEnter}
          onSearch={this.onSearch}
          style={{ width: 200, marginBottom: 8 }}
        />

        <Table
          rowKey={(record)=>record.RNUM}
          columns={columns} 
          dataSource={centerList}
          pagination={false}
          rowSelection={{
            type: 'radio',
            ...rowSelection,
          }}
        />
        <br />
        <div className="page_nav_ct">
          <Pagination
            showSizeChanger={false}
            current={pageInfo !== null ? pageInfo.pageIndex : 1}
            total={pageInfo !== null ? pageInfo.totalCnt : 0}
            pageSize={pageInfo !== null ? pageInfo.recordCountPerPage : 0}
            onChange={this.onPageChange}
          />
        </div>
      </Modal>
    );
  }

}

export default withRouter(CenterListModal);
